import { render, staticRenderFns } from "./logisreqpurchaseV0.vue?vue&type=template&id=113dfcce"
import script from "./logisreqpurchaseV0.vue?vue&type=script&lang=js"
export * from "./logisreqpurchaseV0.vue?vue&type=script&lang=js"
import style0 from "./logisreqpurchaseV0.vue?vue&type=style&index=0&id=113dfcce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports